import { SlateLeaf } from '@all-hands-hq/plex-graphql-schema';
import { makeStyles } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';
import React from 'react';

export function SlateLeafView({
  attributes,
  children,
  leaf,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attributes: { [key: string]: any };
  children?: React.ReactNode;
  leaf: SlateLeaf;
}): React.ReactElement {
  const classes = useStyles();

  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  if (leaf.code) {
    children = <code className={classes.code}>{children}</code>;
  }

  if (leaf.italic) {
    children = <em>{children}</em>;
  }

  if (leaf.underline) {
    children = <u>{children}</u>;
  }

  return <span {...attributes}>{children}</span>;
}

const useStyles = makeStyles((theme) => ({
  code: {
    backgroundColor: grey[300],
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },
}));
